import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable,
  obtenerTotales } from '../actions/TablaCamionesSinDefinitivaActions'
import { TablaCamionesSinDefinitivaView } from '../components/TablaCamionesSinDefinitivaView'

class TablaCamionesSinDefinitiva extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
    this.props.obtenerTotales()
  }

  render () {
    return <TablaCamionesSinDefinitivaView
      estado={this.props.estado}
      pesoNetoOrigen={this.props.pesoNetoOrigen}
      pesoNetoDescargado={this.props.pesoNetoDescargado} />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable,
  obtenerTotales
}

const mapStateToProps = (state) => {
  return {
    estado: state.camionesSinDefinitiva.estado,
    pesoNetoOrigen: state.camionesSinDefinitiva.pesoNetoOrigen,
    pesoNetoDescargado: state.camionesSinDefinitiva.pesoNetoDescargado
  }
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

export default withRedux(TablaCamionesSinDefinitiva)
